// extracted by mini-css-extract-plugin
export default {"collapse":"ImportantRemark_collapse__kG1GT"};